import { render, staticRenderFns } from "./AutoscaleAxis.vue?vue&type=template&id=0bd344ba&"
import script from "./AutoscaleAxis.vue?vue&type=script&lang=js&"
export * from "./AutoscaleAxis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports